export default function LoadingInner() {
  return (
    <div className="relative w-full h-full">
      <div className="flex items-center justify-center h-full">
        <div className="text-center">
          <div className="flex items-center justify-center">
            <div className="kbv-loading-spinner animate-spin rounded-full h-10 w-10 border-t-4"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
